<div class="row justify-content-center">
  <div class="col-12 col-xxl-10">
    <div class="section-header mb-3 d-flex justify-content-between">
      <h1 class="h5 text-colonial mb-0">{{(isClient || (isIntermediary && client) ? 'Reclamos' : 'Seleccione el cliente')}}</h1>
      @if (client){
        <app-client-button (clicked)="client = undefined" [client]="client"></app-client-button>
      }
    </div>
  </div>
</div>
<div class="row justify-content-center">
  <div class="col-12 col-xxl-10">
    <div class="card shadow-sm border-0 overflow-hidden rounded-4">
      <shared-table-container>
        @if(isIntermediary && !client){
          <app-client-selector (selectedClient)="handleSelectedClient($event)"></app-client-selector>
        }@else{
          <shared-table
            (actionButtonClicked)="addClaim()"
            (paginateNext)="paginateNext()"
            (paginatePrev)="paginatePrev()"
            (searching)="handleSearch($event)"
            [headers]="tableHeaders"
            [items]="sortedData"
            [pagination]="pagination"
            actionButtonTitle="Abre tu Reclamo"
            searchPlaceholder="Buscar por póliza"
            title="Reclamaciones"
          >
            <ng-template let-claimID='claimID' let-lossDate='lossDate' sharedTableColumn="lossDate">
              <div class="d-flex align-items-center fw-normal text-uppercase gap-3 p-2">
                <span class="material-symbols-outlined fw-light fs-2">
                car_crash
                </span>
                <div class="d-flex flex-column">
                  <span class="fw-bold">Reclamo: {{claimID}}</span>
                  <span>{{lossDate | date: dateFormats.ddMMyyyy}}</span>
                </div>
              </div>
            </ng-template>
            <ng-template let-policyNumber='policyNumber' sharedTableColumn="policyNumber">
              {{policyNumber | mask: policyMask}}
            </ng-template>
            <ng-template sharedTableColumn="action">
              <a class="btn btn-sm btn-light d-flex align-items-center gap-1" href="https://www.siguelotu.com.do/" target="_blank">
                SigueloTú
                <span class="material-symbols-outlined fs-5 fw-light">
                open_in_new
                </span>
              </a>
            </ng-template>
          </shared-table>
        }
      </shared-table-container>
    </div>
  </div>
</div>
